/**
 * Canvas IO-Pass, as a parent rather than a place.
 *
 * Carries no command: naming IO-Pass, guest access or guest wifi on its own
 * does not say which of the two tabs was meant, so this asks and the answer
 * dispatches to `guest_config.view` or `client_sessions.view`. The same
 * shape as Backup, which asks Site or System.
 *
 * Declared so the operation is known - a resource nobody lists is
 * indistinguishable from one nobody noticed.
 */
const ioPassParentPlugin = {
	id: 'iopass',
	version: 1,
	commandVersion: 1,
	resource: 'iopass',
	operations: ['options'],
	dependencies: {
		plugins: ['canvas.navigation'],
	},
};

export default ioPassParentPlugin;
